import { createClient } from '@sanity/client';

/**
 * NOTE: The CDN client may return stale data.
 * For all static builds (including revalidation builds), the live (non-CDN) client should be used.
 *
 * See https://www.sanity.io/docs/api-cdn
 */

export const sanityClientWithCdn = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ?? '',
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET ?? 'staging', // default to staging for local builds
  apiVersion: 'v2022-08-08',
  useCdn: true,
});
